export const auth = {
  created: function () {
    this.$air.checkAuth()
  }
}



// WEBPACK FOOTER //
// ./src/mixins/auth.js